<template>
  <div class="plugin-buttons" :class="{'multiple': data?.buttons?.length > 1}">
    <template v-for="(button, index) in data?.buttons" :key="index">
      <nuxt-link 
        v-if="button.desktop?.btn_text"
        :to="button.desktop.url || '/'" 
        class="desktop-only btn-link"
      >
        <Button 
          :type="mapStyle(button.desktop.style)" 
          class="tall full-width-mobile coarse"
          :class="{'uppercase': button.desktop.style === 'black'}"
        >
          {{ button.desktop.btn_text }}
          <ExpandIcon v-if="button.desktop.style === 'grey'" stroke="black" class="icon-right" />
        </Button>
      </nuxt-link>

      <nuxt-link 
        v-if="button.mobile?.btn_text"
        :to="button.mobile.url || '/'" 
        class="mobile-only btn-link"
      >
        <Button 
          :type="mapStyle(button.mobile.style)" 
          class="tall full-width-mobile coarse"
          :class="{'uppercase': button.mobile.style === 'black'}"
        >
          {{ button.mobile.btn_text }}
          <ExpandIcon v-if="button.mobile.style === 'grey'" stroke="black" class="icon-right" />
        </Button>
      </nuxt-link>
      
    </template>
  </div>
</template>

<script setup>
import Button from "~/components/atoms/Button.vue";
import ExpandIcon from "~/components/icons/ExpandIcon.vue";

const props = defineProps({
  data: Object,
  settings: Object
})

const mapStyle = (style) => {
  if (style === 'bronze') return 'bronze';
  if (style === 'grey') return 'light-grey';
  return style || 'black';
}
</script>

<style scoped lang="scss">
.plugin-buttons {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 16px;
  width: 100%;

  @include smd {
    flex-direction: column;
    gap: 12px;
  }
}

.btn-link {
  text-decoration: none;
  display: block;
  width: fit-content;

  @include smd {
    width: 100%;
  }

  &:deep(button) {
    min-width: 226px;
    margin: 0;

    &.bronze, &.light-grey {
      font-weight: 600 !important;
    }

    @include smd {
      width: 100%;
      min-width: 0;
    }
  }
}

.icon-right {
  margin-left: 10px;
  width: 16px;
  height: 16px;
}

.desktop-only {
  display: block;
  @include smd {
    display: none;
  }
}

.mobile-only {
  display: none;
  @include smd {
    display: block;
  }
}
</style>
